module.exports = __webpack_public_path__ + "img/Banner1.86ea62c8.png";